import { API, Endpoints, TeamAPI } from "@brg/api";
import { useProfile } from "@brg/auth"
import { set } from "date-fns";
import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";
import { SUBSCRIBE_VISIBILITY_STATUS } from "shared/components/Subscribe/const";
import { setIsLoading } from "shared/reducers/ProfileFoldersSlice";

export const useGetFeedInfo = () => {
    const profile = useProfile();
    const [hasFeedInfo, setHasFeedInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const fetchFeedInfo = async (id: string) => {
        const visibilityOpt = `&visibility=${SUBSCRIBE_VISIBILITY_STATUS.visible}`;
        const subscriberType = '0'
        const targetType = 'team'
        const params = `subscriberId=${profile?.accountId}&subscriberType=${subscriberType}&targetType=${targetType}${visibilityOpt} `
        const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscriptions?${params}`

        try {
            const feedInfo = await urlApi()?.hasSubscribesOrSubscriptions(id)

            const organizationsInfo = await API.fetch(url, {})
                .then((r) => r.json())
                .then((subscriptions) => {
                    const { data: subscriptionsData, paging } = subscriptions;
                    const teamIds = subscriptionsData?.map((i: any) => i?.targetId);
            
                    if (!teamIds?.length) return;
            
                          return TeamAPI.GetList({
                            teamIds,
                            sort: 1
                          }).then((r) => r.json())
                            .then((teamsResponse: any) => {
                                if (teamsResponse?.data?.length > 0) {
                                    return true
                                }
    
                                return false
                })})
    
    
            Promise.all([feedInfo, organizationsInfo]).then((response) => {
                setIsLoading(false);
                setHasFeedInfo(response?.some((status) => !!status))
            });
        }
        catch(err: any){
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (profile) {
            fetchFeedInfo(profile.accountId)
        }
    } , [profile])

    return [hasFeedInfo, isLoading]
}import { API, Endpoints, TeamAPI } from "@brg/api";
import { useProfile } from "@brg/auth"
import { set } from "date-fns";
import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";
import { SUBSCRIBE_VISIBILITY_STATUS } from "shared/components/Subscribe/const";
import { setIsLoading } from "shared/reducers/ProfileFoldersSlice";

export const useGetFeedInfo = () => {
    const profile = useProfile();
    const [hasFeedInfo, setHasFeedInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const fetchFeedInfo = async (id: string) => {
        const visibilityOpt = `&visibility=${SUBSCRIBE_VISIBILITY_STATUS.visible}`;
        const subscriberType = '0'
        const targetType = 'team'
        const params = `subscriberId=${profile?.accountId}&subscriberType=${subscriberType}&targetType=${targetType}${visibilityOpt} `
        const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscriptions?${params}`

        try {
            const feedInfo = await urlApi()?.hasSubscribesOrSubscriptions(id)

            const organizationsInfo = await API.fetch(url, {})
                .then((r) => r.json())
                .then((subscriptions) => {
                    const { data: subscriptionsData, paging } = subscriptions;
                    const teamIds = subscriptionsData?.map((i: any) => i?.targetId);
            
                    if (!teamIds?.length) return;
            
                          return TeamAPI.GetList({
                            teamIds,
                            sort: 1
                          }).then((r) => r.json())
                            .then((teamsResponse: any) => {
                                if (teamsResponse?.data?.length > 0) {
                                    return true
                                }
    
                                return false
                })})
    
    
            Promise.all([feedInfo, organizationsInfo]).then((response) => {
                setIsLoading(false);
                setHasFeedInfo(response?.some((status) => !!status))
            });
        }
        catch(err: any){
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (profile) {
            fetchFeedInfo(profile.accountId)
        }
    } , [profile])

    return [hasFeedInfo, isLoading]
}